import useAfterContextAction from './useAfterContextAction';
import useRangeSelection from './useRangeSelection';

export default function useTextSelection() {
  useAfterContextAction();
  useRangeSelection();
}
